export const replaceTag = (text) => {
    // 만약 #이 없으면 #을 붙여준다.
    if (text.indexOf("#") === -1) {
        text = "#" + text;
    }
    return text;
};
